/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Error_HeadingInputs */

const sv_page_error_heading = /** @type {(inputs: Page_Error_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Något gick fel`)
};

const en_page_error_heading = /** @type {(inputs: Page_Error_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Page_Error_HeadingInputs} inputs
* @param {{ locale?: "sv" | "en" }} options
* @returns {LocalizedString}
*/
export const page_error_heading = /** @type {((inputs?: Page_Error_HeadingInputs, options?: { locale?: "sv" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Error_HeadingInputs, { locale?: "sv" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "sv") return sv_page_error_heading(inputs)
	return en_page_error_heading(inputs)
});